import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';

const stats = [
  { label: "全剧集数", value: "12", unit: "集" },
  { label: "单集时长", value: "45", unit: "分钟" },
  { label: "播出年份", value: "2026", unit: "" },
  { label: "观众评分", value: "9.2", unit: "分" },
];

export default function PlotIntro() {
  return (
    <section className="bg-background-100 border-y border-background-300/40">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-3">
            <h2 className="font-heading font-semibold text-foreground-950 text-2xl md:text-3xl mb-5">
              剧情简介
            </h2>
            <p className="text-foreground-600 leading-loose mb-4">
              《无颜之月》是一部以“记忆与遗忘”为核心的年代悬疑剧。留学归来的插画师<span className="text-foreground-950 font-medium">沈月</span>
              为整理祖母遗物回到山中别院，却在满月之夜，听见了不属于这个时代的脚步。
            </p>
            <p className="text-foreground-600 leading-loose mb-4">
              一本被涂去名字的手札、一盏只为等待而亮的灯、一个记不清自己来历的看守人——
              所有线索都指向同一段被刻意抹去的往事。当满月再次升起，沈月必须亲手决定：记住，还是放手。
            </p>
            <p className="text-foreground-500 leading-loose mb-8">
              全剧共 12 集，以冷静克制的镜头语言与深蓝月夜的视觉基调，讲述一个关于等待、告别与归还的故事。
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/plot"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line" />
                阅读完整剧情
              </Link>
              <Link
                to="/episodes"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-secondary-900 font-medium text-sm hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-list-check-2" />
                浏览全部剧集
              </Link>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-lg overflow-hidden border border-background-300/40 bg-background-50">
              <img
                src={episodes[0].cover}
                alt="无颜之月第一集 月下之门 剧照"
                title="无颜之月 剧情简介 剧照"
                className="w-full h-64 md:h-72 object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 gap-3 mt-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg bg-background-50 border border-background-300/40 px-4 py-3"
                >
                  <p className="font-heading font-semibold text-primary-400 text-2xl leading-none">
                    {s.value}
                    <span className="text-xs text-foreground-500 ml-1 font-body">{s.unit}</span>
                  </p>
                  <p className="text-xs text-foreground-500 mt-1.5">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}